import Layout from "@/layout/Layout.vue";
import { P } from "@/config/permissions";

const facturesAchatRoutes = {
    path: "/factures-achat",
    name: "factures-achat",
    component: Layout,
    redirect: "/factures-achat/liste",
    meta: {
        title: "Factures d'achat",
        icon: "mdi:file-document-outline",
        permissions: [P.FACTURES_ACHAT.BROWSE],
        noCache: true
    },
    children: [
        {
            path: "liste",
            name: "factures-achat-liste",
            meta: {
                title: "Factures d'achat",
                icon: "mdi:file-document-outline",
                noCache: true,
                permissions: [P.FACTURES_ACHAT.BROWSE],
                // Pastille du menu : nombre de factures reçues qu'aucun membre
                // du service comptable n'a encore ouvertes. Déclarée sur CE seul
                // niveau — le SidebarItem somme les descendants, la déclarer
                // aussi sur le parent compterait deux fois.
                badgeKey: "facturesAchat"
            },
            component: () => import("@/views/facturesAchat/FacturesAchat.vue")
        },
        {
            path: ":id(\\d+)",
            name: "factures-achat-show",
            meta: {
                title: "Détail facture d'achat",
                noCache: true,
                permissions: [P.FACTURES_ACHAT.VIEW]
            },
            component: () => import("@/views/facturesAchat/showFacture.vue"),
            hidden: true
        }
    ]
};

export default facturesAchatRoutes;
